import { render, staticRenderFns } from "./EModalTurmasFranquia.vue?vue&type=template&id=375bf9f9&scoped=true"
import script from "./EModalTurmasFranquia.vue?vue&type=script&lang=js"
export * from "./EModalTurmasFranquia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375bf9f9",
  null
  
)

export default component.exports